/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockUp = createReactComponent("clock-up", "IconClockUp", [
  ["path", { d: "M20.983 12.548a9 9 0 1 0 -8.45 8.436", key: "svg-0" }],
  ["path", { d: "M19 22v-6", key: "svg-1" }],
  ["path", { d: "M22 19l-3 -3l-3 3", key: "svg-2" }],
  ["path", { d: "M12 7v5l2.5 2.5", key: "svg-3" }]
]);

export { IconClockUp as default };
//# sourceMappingURL=IconClockUp.js.map
